import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getDeactivateLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const DeactivateHistory = (props) => {
  const [deactivateHistory, setDeactivateHistory] = useState([]);
  const { deactivate_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getDeactivateLog(deactivate_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setDeactivateHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Deactivate Log
        </Typography>
      </Box>

      {response && deactivateHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {deactivateHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/ultra/deactivate/batch/${deactivateHistory.data.batch_id}`}
                      >
                        {deactivateHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={deactivateHistory.data.status}
                        size="small"
                        color={getChipColor(deactivateHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {deactivateHistory.data.last_updated &&
                        `${format(
                          new Date(deactivateHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={deactivateHistory.history.data} />
        </>
      ): (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default DeactivateHistory;
